module.exports = __webpack_public_path__ + "static/media/map-generic.0917c410.svg";